<template>
  <div class="popup-wrap">
    <div class="edit_order_container row">
      <div class="position-relative form-group col-12">
        <ul class="flags">
          <li v-for="(object, flag) in data.more.flags" :key="flag" class="radio-container">
            <input :readonly="!editable.order" type="radio" name="flag" :checked="data.flag == flag" :value="flag" @change="data.flag = $event.currentTarget.value" />
            <span :class="`checkmark choose-flag ${flag}`"></span>
          </li>
        </ul>
      </div>

      <div class="position-relative form-group col-12">
        <label class="col-12 mb-0 p-0">Name*</label>
        <input :readonly="!editable.order" class="form-control mt-2" type="text" name="delivery_info[name]" v-model="data.delivery_info.name" />
      </div>
      <div class="position-relative form-group col-12">
        <label class="col-12 mb-0 p-0">Phone</label>
        <input :readonly="!editable.order" class="form-control mt-2" type="text" name="delivery_info[phone]" v-model="data.delivery_info.phone" />
      </div>
      <div class="position-relative form-group col-12">
        <label class="col-12 mb-0 p-0">Email</label>
        <input :readonly="!editable.order" class="form-control mt-2" type="text" name="delivery_info[email]" v-model="data.delivery_info.email" />
      </div>
      <div class="position-relative form-group col-6">
        <label class="col-12 mb-0 p-0">First line*</label>
        <input :readonly="!editable.order" class="form-control mt-2" type="text" name="delivery_info[line][]" v-model="data.delivery_info.line[0]" />
      </div>
      <div class="position-relative form-group col-6">
        <label class="col-12 mb-0 p-0">Second line</label>
        <input :readonly="!editable.order" class="form-control mt-2" type="text" name="delivery_info[line][]" v-model="data.delivery_info.line[1]" />
      </div>
      <div class="position-relative form-group col-12">
        <label class="col-12 mb-0 p-0">City*</label>
        <input :readonly="!editable.order" class="form-control mt-2" type="text" name="delivery_info[city]" v-model="data.delivery_info.city" />
      </div>
      <div class="position-relative form-group col-12">
        <label class="col-12 mb-0 p-0">State</label>
        <Select source="order/state/search" :params="{ country: data.delivery_info.country }" v-model="data.delivery_info.state" :taggable="true"></Select>
      </div>
      <div class="position-relative form-group col-12">
        <label class="col-12 mb-0 p-0">Zip*</label>
        <input :readonly="!editable.order" class="form-control mt-2" type="text" name="delivery_info[zip]" v-model="data.delivery_info.zip" />
      </div>
      <div class="position-relative form-group col-12">
        <label class="col-12 mb-2 p-0">Country</label>
        <input class="form-control mt-2" type="text" :value="data.delivery_info.country_label" disabled />
      </div>
      <div class="position-relative form-group col-12">
        <label class="col-12 mb-0 p-0">Note</label>
        <input :readonly="!editable.order" class="form-control mt-2" type="text" name="note" v-model="data.note" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    data() {
      return this.config?.data
    },
    editable() {
      return this.config?.editable || {}
    }
  },
  props: {
    config: Object
  }
}
</script>
